export type Plan = "monthly" | "quarterly";

/**
 * Either a hosted-checkout URL to redirect to, or a signal that the email
 * already has a live subscription (so the UI should route them into MANAGE
 * SUBSCRIPTION instead of opening a second one).
 */
export type CheckoutResponse =
  | { url: string }
  | { alreadySubscribed: true };

export interface PortalRequestResponse {
  ok: true;
}

const BASE = import.meta.env.VITE_API_BASE ?? "";

async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const data = (await res.json()) as { message?: string };
      if (data.message) message = data.message;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return (await res.json()) as T;
}

export function createCheckoutSession(
  plan: Plan,
  email: string,
): Promise<CheckoutResponse> {
  return postJson<CheckoutResponse>("/api/checkout-session", { plan, email });
}

/**
 * Request a billing-portal magic link. The server emails a single-use link
 * to the address if it matches a Stripe customer. The response is always
 * generic — we never reveal whether the email matched.
 */
export function requestPortalLink(email: string): Promise<PortalRequestResponse> {
  return postJson<PortalRequestResponse>("/api/portal/request", { email });
}
